import { onLoadComplete, getIndexedHashProperty, getBreakpoint } from './_utils';
import { getNavigationBarHeight } from './navigation';

const cssClasses = ['Experiences', 'RelatedLinks', 'CardTrio', 'Text-Box'];

const selectors = {
	topNav: '#TopNav-mainNav',
	secondaryExperience: '.ImageCtaCollage-item',
};

const findScrollToElement = indexedHashProperty => {
	const $scrollToElements = $(`#${indexedHashProperty.id}`);
	if ($scrollToElements.length) {
		let $scrollToElement = $scrollToElements.first();
		if ($scrollToElement.hasClass('emptyAnchor')) {
			$scrollToElement = $scrollToElement.parent();
		}
		const obClass = cssClasses.filter(itemClass => {
			return $scrollToElement.hasClass(itemClass);
		});
		if (obClass.length) {
			if (
				obClass.includes('Experiences') &&
				indexedHashProperty.index > 1 &&
				$scrollToElement.find('.flickity-enabled').length == 0
			) {
				const secondaryExperienceElements = $scrollToElement.find(
					selectors.secondaryExperience
				);
				if (
					secondaryExperienceElements &&
					secondaryExperienceElements.length >= indexedHashProperty.index
				) {
					$scrollToElement = secondaryExperienceElements.eq(
						indexedHashProperty.index - 1
					);
				}
			}
			return $scrollToElement;
		}
	}
	return null;
};

export default function scrollToQueryHash() {
	onLoadComplete(() => {
		const indexedHashProperty = getIndexedHashProperty();
		if (indexedHashProperty) {
			const $scrollToEl = findScrollToElement(indexedHashProperty);

			scrollToElement($scrollToEl);
		}
	});
}

export function scrollToElement($jqueryObj) {
	if ($jqueryObj) {
		const topNavHeight = getNavigationBarHeight();
		const additionalHeight = getUnderHeroHeightThatWillGoAwayWithScroll();
		window.scroll({
			left: 0,
			top: $jqueryObj.offset().top - topNavHeight - additionalHeight,
			behavior: 'smooth',
		});
	}
}

const getUnderHeroHeightThatWillGoAwayWithScroll = () => {
	let height = 0;

	// only matters on desktop
	const bp = getBreakpoint();
	if (['large', 'xlarge'].includes(bp)) {
		// grap the Fullscreen hero piece, if present
		const underHero = $('.FullscreenHero-underHero');

		if (underHero.length) {
			height = underHero.height();
		}
	}

	return height;
};
